import { render, staticRenderFns } from "./wxAuth.vue?vue&type=template&id=15df3d28&scoped=true"
import script from "./wxAuth.vue?vue&type=script&lang=js"
export * from "./wxAuth.vue?vue&type=script&lang=js"
import style0 from "./wxAuth.vue?vue&type=style&index=0&id=15df3d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15df3d28",
  null
  
)

export default component.exports